import { render, staticRenderFns } from "./hubinscanoutscan_details.vue?vue&type=template&id=8b3f0612"
import script from "./hubinscanoutscan_details.vue?vue&type=script&lang=js"
export * from "./hubinscanoutscan_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports